import PageTemplate from "../components/common/PageTemplate";
import ListTransactionNew from "../screen/purchase/transaction/ListTransactionNew";

const TransactionListPage = () => {
  return (
    <PageTemplate
      mainComponent={<ListTransactionNew />}
      noPadding={true}
      logo={"Pesanan"}
    />
  );
};

export default TransactionListPage;
